<template>
  <v-banner v-if="visibility" lines="one" transition="slide-y-transition" class="notification-banner">
    <v-row no-gutters align="center" style="height: 46px">
      <v-icon color="#159dbb" size="24" class="mr-6">mdi-phone-ring</v-icon>
      <span class="notification-banner-text">{{ t('$vuetify.__NotificationBanner.new_call') }}</span>

      <v-spacer></v-spacer>

      <v-btn variant="text" size="small" color="#1b65f2" class="notification-banner-btn text-none px-3" @click="store.commit('RESET_NOTIFICATION_BANNER')">
        {{ t('$vuetify.close') }}
      </v-btn>
      <v-btn variant="text" size="small" color="#1b65f2" class="notification-banner-btn text-none px-3 mr-3" @click="store.dispatch('selectVideoCall', { mode: 'banner', item: real_session_id })">
        {{ t('$vuetify.__NotificationBanner.view_call') }}
      </v-btn>

      <audio id="notification_audio" src="https://files.asiabots.com/projects/demo/241003T173951973875_video_call_noti_sound.mp3" style="display: none"></audio>
    </v-row>
  </v-banner>
</template>

<script setup>
import { useLocale } from 'vuetify'
const { t } = useLocale()
import { useStore } from 'vuex'
const store = useStore()

import { computed, nextTick, watch } from 'vue'

const visibility = computed({
  get() {
    return store.state.notificationBanner.visibility
  },
  set(value) {
    store.commit('SET_NOTIFICATION_BANNER_VISIBILITY', value)
  }
})
const real_session_id = computed(() => store.state.notificationBanner.real_session_id)

watch(visibility, () => {
  if (visibility.value) {
    nextTick(() => {
      const audio = document.getElementById('notification_audio')
      if (audio) {
        audio.play()
      }
    })
  } else {
    nextTick(() => {
      const audio = document.getElementById('notification_audio')
      if (audio) {
        audio.pause()
        audio.currentTime = 0
      }
    })
  }
})
</script>

<style scoped>
.notification-banner {
  position: absolute;
  top: 64px;
  height: 65px;
  width: 100vw;
  background: #fff !important;
  z-index: 2000;
}

:deep(.v-banner__wrapper) {
  height: 100%;
  padding: 8px 24px 8px 32px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.notification-banner-text {
  color: #1a1a1a;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.notification-banner-btn {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}
</style>
